import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { API, setToken, getToken, errMsg, assetUrl } from "@/lib/api";
import { useSite } from "@/context/SiteContext";

export default function AdminLogin() {
  const { content } = useSite();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  if (getToken()) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      setToken(data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ivory-alt grid place-items-center px-4 font-arial-all" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl bg-white shadow-xl border-t-4 border-brand p-8 space-y-5">
        <img src={assetUrl(content.general.logo)} alt="ISD" className="h-10 w-auto" />
        <div className="flex items-center gap-2 text-charcoal"><Lock className="h-4 w-4 text-brand" /><h1 className="text-lg font-bold">Admin sign in</h1></div>
        <div className="space-y-1.5">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
        </div>
        {error && <p className="text-sm text-destructive" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" disabled={busy} className="w-full bg-brand hover:bg-brand-dark" data-testid="admin-login-submit">
          {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Sign in
        </Button>
      </form>
    </div>
  );
}
